var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-gray-200 text-gray-800 border-r"},[_c('h2',{staticClass:"p-4 font-medium uppercase text-gray-500 tracking-wide"},[_vm._v("\n      Categories\n    ")]),_vm._v(" "),_c('ais-hierarchical-menu',{staticClass:"font text-sm mb-4",attrs:{"attributes":[
        'categories.level1',
        'categories.level2',
        'categories.level3',
      ],"limit":999}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }